import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import "./index.css";
//for upload image
import "./global.css";
/////////

import Introduction from "./Introduction";
import ProductPage from "./ProductPage";
import AddPage from "./add-ui/ToyImageUpload";
import AddStory from "./AddStory";
import AddVideo from "./AddVideo";
import StoryDetail from "./StoryDetail";
import VideoDetail from "./VideoDetail";
import ToyEdit from "./toyEdit/ToyEdit";
import Layout from "./Layout";
import AdminWaitlist from "./adminPages/AdminWaitlist";
import AdminDashboard from "./adminPages/AdminDashboard";
import AdminProfile from "./adminPages/AdminProfile";
import AdminSignIn from "./adminPages/AdminSignIn";
import AdminSignOut from "./adminPages/AdminSignOut";
import AdminModeration from "./adminPages/AdminModeration";
import AdminReportEdit from "./adminPages/AdminReportEdit";
import SearchResults from "./SearchResults";
import SignIn from "./SignIn";
import UpdatePassword from "./UpdatePassword";
import UpdatePasswordConfirmation from "./UpdatePasswordConfirmation";
import ResetPassword from "./ResetPassword";
import SignUp from "./SignUp";
import SignupSuccess from "./SignupSuccess";
import SignupActivation from "./SignupActivation";
import SignOut from "./SignOut";
import Dashboard from "./Dashboard";
import Profile from "./Profile";
import ToysList from "./ToysList";
import PurchasedToysList from "./PurchasedToysList";
import MyCollection from "./MyCollection";
import MyRatings from "./MyRatings";
import MyStories from "./MyStories";
import MyVideos from "./MyVideos";
import MyFollowings from "./MyFollowings";
import MyFollowers from "./MyFollowers";
import EmptyPage from "./EmptyPage";
import InvalidPage from "./InvalidPage";
import UserHomePage from "./UserHomePage";
import SearchResultsPage from "./SearchResultsPage";
import AdminToysList from "./adminPages/AdminToysList";
import AdminStoriesList from "./adminPages/AdminStoriesList";
import AdminVideosList from "./adminPages/AdminVideosList";
import AdminUsersList from "./adminPages/AdminUsersList";
import StoryEdit from "./EditStory";
import VideoEdit from "./EditVideo";
import AuthWrapper from "./AuthWrapper";

// Public Pages
import PublicProfile from "./publicPages/PublicProfile";
import PublicListings from "./publicPages/PublicListings";
import PublicRatings from "./publicPages/PublicRatings";
import PublicFollowing from "./publicPages/PublicFollowing";
import PublicFollowers from "./publicPages/PublicFollowers";
import PublicStories from "./publicPages/PublicStories";
import PublicVideos from "./publicPages/PublicVideos";

// Corporate Pages
import Home from "./Home";
import AboutUs from "./corporatePages/AboutUs";
import HowR3playWorks from "./corporatePages/HowR3playWorks";
import Contact from "./corporatePages/Contact";
import PrivacyPolicy from "./corporatePages/PrivacyPolicy";
import TermsOfUse from "./corporatePages/TermsOfUse";
import CookiePolicy from "./corporatePages/CookiePolicy";

// Shipping Pages
import OrderDetails from "./shippingPages/OrderDetails";
import CreateShippingLabel from "./shippingPages/CreateShippingLabel";
import ShippingLabelView from "./shippingPages/ShippingLabelView";
import ShipItem from "./shippingPages/ShipItem";

import { ClientContext, GraphQLClient } from "graphql-hooks";

// Create MUI theme
const theme = createTheme({
  palette: {
    primary: {
      main: "#E53935",
    },
    secondary: {
      main: "#4CAF50",
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 950, //600
      md: 1270, //900 1400
      lg: 1400, //1600,
      xl: 1536, //1900,
      customBreakpoint: 735,
    },
  },
  components: {
    // Global configuration for all Select components
    MuiSelect: {
      defaultProps: {
        MenuProps: {
          disableScrollLock: true,
        },
      },
    },
    // Global configuration for all Menu components
    MuiMenu: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
    // Global configuration for all Popover components (used by dropdowns)
    MuiPopover: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
    // Global configuration for TablePagination Select
    MuiTablePagination: {
      defaultProps: {
        SelectProps: {
          MenuProps: {
            disableScrollLock: true,
          },
        },
      },
    },
    // Global configuration for all Dialog components
    MuiDialog: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
  },
});

document.addEventListener(
  "scroll",
  event => {
    // Find all open Material-UI dropdowns
    const openDropdowns = document.querySelectorAll(
      '[role="presentation"] .MuiPaper-root'
    );
    const openSelects = document.querySelectorAll(
      '.MuiSelect-select[aria-expanded="true"]'
    );

    // Check if scroll is happening inside any dropdown
    const isScrollingInsideDropdown = Array.from(openDropdowns).some(dropdown =>
      dropdown.contains(event.target)
    );

    if (!isScrollingInsideDropdown) {
      // Close all dropdowns by clicking outside
      openSelects.forEach(select => {
        const backdrop = document.querySelector(".MuiBackdrop-root");
        if (backdrop) backdrop.click();
      });
    }
  },
  true
);

// Access env variables
console.log(process.env);
const graphqlUrl = process.env.REACT_APP_API_URL || "http://localhost:8000/graphql";
const basename = process.env.REACT_APP_BASE_PATH || "/";
const adminURL = process.env.REACT_APP_ADMIN_URL || "/t31u4YYky50K";
console.log("GraphQL URL:", graphqlUrl);
console.log("Base Path:", basename);

const client = new GraphQLClient({
  // useGETForQueries: false,
  url: graphqlUrl,
  //headers: { Authorization: token ? `JWT ${token}` : "" },
  //fetchOptions: () => {
  //  return {
  //    headers: { Authorization: token ? `JWT ${token}` : "" },
  //  };
  //},
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <React.StrictMode>
      <ClientContext.Provider value={client}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Router basename={basename}>
            <Layout>
              <Routes>
                {/* Public Routes - No Authentication Required */}
                {/*<Route path="/" element={<Introduction />} />*/}
                <Route path="/signin" element={<SignIn />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/signup-success" element={<SignupSuccess />} />
                <Route
                  path="/signup-activation/:activationCode"
                  element={<SignupActivation />}
                />
                <Route path="/signout" element={<SignOut />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/update-password/:forgetCode" element={<UpdatePassword />} />
                <Route
                  path="/update-password-confirmation"
                  element={<UpdatePasswordConfirmation />}
                />

                {/* Corporate Pages - No Authentication Required */}
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/how-r3play-works" element={<HowR3playWorks />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-use" element={<TermsOfUse />} />
                <Route path="/cookie-policy" element={<CookiePolicy />} />
                <Route path={adminURL + "/signin"} element={<AdminSignIn />} />
                <Route path={adminURL + "/signout"} element={<AdminSignOut />} />

                {/* Protected Routes - Authentication Required */}
                <Route
                  path="/toy/:toyUuid"
                  element={
                    <AuthWrapper>
                      <ProductPage />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/add-ui"
                  element={
                    <AuthWrapper>
                      <AddPage />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/story-add"
                  element={
                    <AuthWrapper>
                      <AddStory />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/video-add"
                  element={
                    <AuthWrapper>
                      <AddVideo />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/story/:storyUuid"
                  element={
                    <AuthWrapper>
                      <StoryDetail />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/story/:storyUuid/edit"
                  element={
                    <AuthWrapper>
                      <StoryEdit />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/video/:videoUuid"
                  element={
                    <AuthWrapper>
                      <VideoDetail />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/video/:videoUuid/edit"
                  element={
                    <AuthWrapper>
                      <VideoEdit />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/toy/:toyUuid/edit"
                  element={
                    <AuthWrapper>
                      <ToyEdit />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/my-toys"
                  element={
                    <AuthWrapper>
                      <ToysList />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/mytoys-purchased"
                  element={
                    <AuthWrapper>
                      <PurchasedToysList />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/my-collections"
                  element={
                    <AuthWrapper>
                      <MyCollection />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/my-ratings"
                  element={
                    <AuthWrapper>
                      <MyRatings />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/my-stories"
                  element={
                    <AuthWrapper>
                      <MyStories />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/my-videos"
                  element={
                    <AuthWrapper>
                      <MyVideos />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/my-followings"
                  element={
                    <AuthWrapper>
                      <MyFollowings />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/my-followers"
                  element={
                    <AuthWrapper>
                      <MyFollowers />
                    </AuthWrapper>
                  }
                />
                <Route
                  path={adminURL + "/waitlist"}
                  element={
                    <AuthWrapper>
                      <AdminWaitlist />
                    </AuthWrapper>
                  }
                />
                <Route
                  path={adminURL + "/dashboard"}
                  element={
                    <AuthWrapper>
                      <AdminDashboard />
                    </AuthWrapper>
                  }
                />
                <Route
                  path={adminURL + "/profile"}
                  element={
                    <AuthWrapper>
                      <AdminProfile />
                    </AuthWrapper>
                  }
                />
                <Route
                  path={adminURL + "/moderation-list"}
                  element={
                    <AuthWrapper>
                      <AdminModeration />
                    </AuthWrapper>
                  }
                />
                <Route
                  path={adminURL + "/report/:uuid"}
                  element={
                    <AuthWrapper>
                      <AdminReportEdit />
                    </AuthWrapper>
                  }
                />
                <Route
                  path={adminURL + "/toys-list"}
                  element={
                    <AuthWrapper>
                      <AdminToysList />
                    </AuthWrapper>
                  }
                />
                <Route
                  path={adminURL + "/stories-list"}
                  element={
                    <AuthWrapper>
                      <AdminStoriesList />
                    </AuthWrapper>
                  }
                />
                <Route
                  path={adminURL + "/videos-list"}
                  element={
                    <AuthWrapper>
                      <AdminVideosList />
                    </AuthWrapper>
                  }
                />
                <Route
                  path={adminURL + "/users-list"}
                  element={
                    <AuthWrapper>
                      <AdminUsersList />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/search-results"
                  element={
                    <AuthWrapper>
                      <SearchResults />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/dashboard"
                  element={
                    <AuthWrapper>
                      <Dashboard />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/my-profile"
                  element={
                    <AuthWrapper>
                      <Profile />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/TBD"
                  element={
                    <AuthWrapper>
                      <EmptyPage />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/invalid-page"
                  element={
                    <AuthWrapper>
                      <InvalidPage />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/:username/home"
                  element={
                    <AuthWrapper>
                      <UserHomePage />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/search"
                  element={
                    <AuthWrapper>
                      <SearchResultsPage />
                    </AuthWrapper>
                  }
                />

                {/* Public User Pages */}
                <Route
                  path="/user/:userUuid/profile"
                  element={
                    <AuthWrapper>
                      <PublicProfile />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/user/:userUuid/listings"
                  element={
                    <AuthWrapper>
                      <PublicListings />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/user/:userUuid/ratings"
                  element={
                    <AuthWrapper>
                      <PublicRatings />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/user/:userUuid/followings"
                  element={
                    <AuthWrapper>
                      <PublicFollowing />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/user/:userUuid/followers"
                  element={
                    <AuthWrapper>
                      <PublicFollowers />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/user/:userUuid/stories"
                  element={
                    <AuthWrapper>
                      <PublicStories />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/user/:userUuid/videos"
                  element={
                    <AuthWrapper>
                      <PublicVideos />
                    </AuthWrapper>
                  }
                />

                {/* Shipping Pages */}
                <Route
                  path="/seller/orders/:orderId"
                  element={
                    <AuthWrapper>
                      <OrderDetails />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/seller/orders/:orderId/shipper"
                  element={
                    <AuthWrapper>
                      <CreateShippingLabel />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/seller/orders/:orderId/shipping-label"
                  element={
                    <AuthWrapper>
                      <ShippingLabelView />
                    </AuthWrapper>
                  }
                />
                <Route
                  path="/seller/orders/:orderId/ship-item"
                  element={
                    <AuthWrapper>
                      <ShipItem />
                    </AuthWrapper>
                  }
                />

                {/* redirects any undefined route to root */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </Router>
        </ThemeProvider>
      </ClientContext.Provider>
    </React.StrictMode>
  </HelmetProvider>
);
